module.exports = __webpack_public_path__ + "img/ring_y_l_1_1@2x.af6428c9.png";